import { c as _c } from "react/compiler-runtime";
import { FeatureViewed } from '@cc-shopping/platform-analytics/FeatureViewed';
import { usePageAction } from '@cc-shopping/platform-analytics/hooks/usePageAction';
import { CTASearchParams } from '@cc-shopping/platform-analytics/lib/ctaSearchParams';
import { BEST_OF_AWARDS_WINNERS_MAP } from '@cc-shopping/ui/composites/BestOfAwardsBanner/utils';
import { BulletPointList } from '@cc-shopping/ui/primitives/BulletPointList';
import { Box, List, ListItem, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useReviewContext } from 'src/app/credit-cards/reviews/components/Context';
import { CtaLink } from 'src/features/product-card/CTA/CtaLink';
import { DetailsAccordionAccordion } from './components/DetailsAccordionAccordion';
export default function ReviewDetailAccordions() {
  const $ = _c(73);
  const {
    marketplaceEntity: t0
  } = useReviewContext();
  const {
    ctaAnalytics,
    finishType,
    id: offerId,
    institution: t1,
    marketingBullets,
    annualFeeDetails,
    rewardRateDetails,
    signUpBonusDetails,
    aprIntroMessageList,
    aprDisplayList,
    driverBalanceTransferFeeDescription: t2,
    driverForeignTransactionFee: t3,
    termsAndFeesLink,
    showCTA,
    name,
    displayName
  } = t0;
  const {
    name: issuerName
  } = t1;
  const {
    description: balanceTransferFeeDescription,
    value: balanceTransferFeeValue
  } = t2;
  const {
    description: foreignTransactionFeeDescription,
    value: foreignTransactionFeeValue
  } = t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      actionName: "accordion_item",
      actionSection: ""
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const fireExpandCollapsePageAction = usePageAction(t4);
  let T0;
  let T1;
  let T2;
  let T3;
  let hasAward;
  let t10;
  let t11;
  let t12;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[1] !== annualFeeDetails || $[2] !== aprDisplayList || $[3] !== aprIntroMessageList || $[4] !== balanceTransferFeeDescription || $[5] !== balanceTransferFeeValue || $[6] !== fireExpandCollapsePageAction || $[7] !== foreignTransactionFeeDescription || $[8] !== foreignTransactionFeeValue || $[9] !== offerId || $[10] !== rewardRateDetails || $[11] !== signUpBonusDetails) {
    const driversRenderer = {
      "Annual fee": [annualFeeDetails],
      "Rewards rate": [rewardRateDetails],
      "Bonus offer": [signUpBonusDetails],
      "Intro APR": aprIntroMessageList,
      "Ongoing APR": aprDisplayList,
      "Balance transfer fee": [balanceTransferFeeDescription || balanceTransferFeeValue],
      "Foreign transaction fee": [foreignTransactionFeeDescription || foreignTransactionFeeValue]
    } as const;
    hasAward = !!BEST_OF_AWARDS_WINNERS_MAP[offerId];
    T3 = Grid;
    t12 = 12;
    T2 = FeatureViewed;
    t9 = "accordion_item";
    t10 = "rate_fees_and_offers";
    t11 = 3;
    T1 = DetailsAccordionAccordion;
    t7 = "Rates, fees and offers";
    if ($[25] !== fireExpandCollapsePageAction) {
      t8 = expanded => {
        fireExpandCollapsePageAction({
          action_input: "0",
          action_section: "rate_fees_and_offers",
          action_type: expanded ? "expand" : "collapse"
        });
      };
      $[25] = fireExpandCollapsePageAction;
      $[26] = t8;
    } else {
      t8 = $[26];
    }
    T0 = List;
    t5 = true;
    t6 = Object.entries(driversRenderer).map(_temp2);
    $[1] = annualFeeDetails;
    $[2] = aprDisplayList;
    $[3] = aprIntroMessageList;
    $[4] = balanceTransferFeeDescription;
    $[5] = balanceTransferFeeValue;
    $[6] = fireExpandCollapsePageAction;
    $[7] = foreignTransactionFeeDescription;
    $[8] = foreignTransactionFeeValue;
    $[9] = offerId;
    $[10] = rewardRateDetails;
    $[11] = signUpBonusDetails;
    $[12] = T0;
    $[13] = T1;
    $[14] = T2;
    $[15] = T3;
    $[16] = hasAward;
    $[17] = t10;
    $[18] = t11;
    $[19] = t12;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    T0 = $[12];
    T1 = $[13];
    T2 = $[14];
    T3 = $[15];
    hasAward = $[16];
    t10 = $[17];
    t11 = $[18];
    t12 = $[19];
    t5 = $[20];
    t6 = $[21];
    t7 = $[22];
    t8 = $[23];
    t9 = $[24];
  }
  let t13;
  if ($[27] !== T0 || $[28] !== t5 || $[29] !== t6) {
    t13 = <T0 disablePadding={t5}>{t6}</T0>;
    $[27] = T0;
    $[28] = t5;
    $[29] = t6;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== T1 || $[32] !== t13 || $[33] !== t7 || $[34] !== t8) {
    t14 = <T1 title={t7} onChange={t8}>{t13}</T1>;
    $[31] = T1;
    $[32] = t13;
    $[33] = t7;
    $[34] = t8;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== T2 || $[37] !== t10 || $[38] !== t11 || $[39] !== t14 || $[40] !== t9) {
    t15 = <T2 entityName={t9} entitySection={t10} impressionPosition={t11}>{t14}</T2>;
    $[36] = T2;
    $[37] = t10;
    $[38] = t11;
    $[39] = t14;
    $[40] = t9;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  const t16 = `More details from ${issuerName}`;
  let t17;
  if ($[42] !== fireExpandCollapsePageAction) {
    t17 = expanded_0 => {
      fireExpandCollapsePageAction({
        action_input: "1",
        action_section: "more_details",
        action_type: expanded_0 ? "expand" : "collapse"
      });
    };
    $[42] = fireExpandCollapsePageAction;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== hasAward) {
    t18 = hasAward && {
      additionalDetailsStyles: {
        borderBottomLeftRadius: "8px",
        borderBottomRightRadius: "8px"
      },
      additionalSummaryStyles: {
        borderBottomLeftRadius: "8px",
        borderBottomRightRadius: "8px"
      }
    };
    $[44] = hasAward;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== ctaAnalytics || $[47] !== displayName || $[48] !== finishType || $[49] !== name || $[50] !== showCTA || $[51] !== termsAndFeesLink) {
    t19 = termsAndFeesLink && showCTA && <CtaLink href={termsAndFeesLink} analytics={{
      ...ctaAnalytics,
      section: {
        ...ctaAnalytics.section,
        name: "review_product_card",
        position: 0
      }
    }} finishType={finishType} type="RATES_AND_FEES_TEXT" rel="nofollow" target="_blank" parameterActions={[CTASearchParams.MONETIZING, CTASearchParams.SHOPPING_FINISH]} aria-label={`View rates and fees for ${displayName || name}`}>View Rates and Fees</CtaLink>;
    $[46] = ctaAnalytics;
    $[47] = displayName;
    $[48] = finishType;
    $[49] = name;
    $[50] = showCTA;
    $[51] = termsAndFeesLink;
    $[52] = t19;
  } else {
    t19 = $[52];
  }
  let t20;
  if ($[53] !== marketingBullets) {
    t20 = marketingBullets || [];
    $[53] = marketingBullets;
    $[54] = t20;
  } else {
    t20 = $[54];
  }
  let t21;
  if ($[55] !== t20) {
    t21 = t20.map(_temp3);
    $[55] = t20;
    $[56] = t21;
  } else {
    t21 = $[56];
  }
  const t22 = termsAndFeesLink ? 1 : 0;
  let t23;
  if ($[57] !== t22) {
    t23 = {
      listStylePosition: null,
      paddingY: 0,
      paddingTop: t22
    };
    $[57] = t22;
    $[58] = t23;
  } else {
    t23 = $[58];
  }
  let t24;
  if ($[59] !== t21 || $[60] !== t23) {
    t24 = <Box marginLeft="1.25rem"><BulletPointList items={t21} renderItem={_temp4} customContainerStyle={t23} /></Box>;
    $[59] = t21;
    $[60] = t23;
    $[61] = t24;
  } else {
    t24 = $[61];
  }
  let t25;
  if ($[62] !== t16 || $[63] !== t17 || $[64] !== t18 || $[65] !== t19 || $[66] !== t24) {
    t25 = <FeatureViewed entityName="accordion_item" entitySection="more_details" impressionPosition={4}><DetailsAccordionAccordion title={t16} onChange={t17} {...t18}>{t19}{t24}</DetailsAccordionAccordion></FeatureViewed>;
    $[62] = t16;
    $[63] = t17;
    $[64] = t18;
    $[65] = t19;
    $[66] = t24;
    $[67] = t25;
  } else {
    t25 = $[67];
  }
  let t26;
  if ($[68] !== T3 || $[69] !== t12 || $[70] !== t15 || $[71] !== t25) {
    t26 = <T3 size={t12}>{t15}{t25}</T3>;
    $[68] = T3;
    $[69] = t12;
    $[70] = t15;
    $[71] = t25;
    $[72] = t26;
  } else {
    t26 = $[72];
  }
  return t26;
}
function _temp4(t0) {
  const {
    item
  } = t0;
  return item.label;
}
function _temp3(bullet) {
  return {
    label: bullet
  };
}
function _temp2(t0) {
  const [label, value] = t0;
  if (!value.filter(Boolean).length) {
    return null;
  }
  return <ListItem key={label} sx={{
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    paddingX: 0
  }}><Typography variant="inherit" marginBottom={1} fontWeight="700">{label}</Typography>{(value || []).map(_temp)}</ListItem>;
}
function _temp(message) {
  return <Typography sx={{
    WebkitFontSmoothing: "antialiased"
  }} key={message}>{message}</Typography>;
}